// extracted by mini-css-extract-plugin
module.exports = {"divider":"PlasmicNewsDivider_divider__fJzDZ"};